import { InlineEditPropsStrict } from '@servicetitan/design-system';

export enum UrgentFollowUpTabs {
  Open = 'Open',
  Cold = 'Cold',
  Done = 'Done',
}

export type InlineEditControlProps = Parameters<
  Exclude<InlineEditPropsStrict['control'], undefined>
>[0];

export type DismissModalError = {
  title: string;
  retry?: () => void;
  retryLabel?: string;
};

export enum TranslatedFollowUpStatus {
  New = 'New',
  ContactAttempted = 'Contact Attempted',
  FollowUpNeeded = 'Follow-Up Needed',
  Resolved = 'Resolved',
  Dismissed = 'Dismissed',
}

export enum TranslatedCallType {
  Abandoned = 'Abandoned',
  Unbooked = 'Unbooked',
  Excused = 'Excused',
  Booked = 'Booked',
  NotLead = 'Not Lead',
}

export const validTranslatedFollowUpUpdateStatuses = [
  TranslatedFollowUpStatus.New,
  TranslatedFollowUpStatus.ContactAttempted,
  TranslatedFollowUpStatus.FollowUpNeeded,
  TranslatedFollowUpStatus.Resolved,
];

export type ClickableButtonHandler<T = any> = (props: { dataItem: T }) => void;
